module.exports = __webpack_public_path__ + "17d2237db5a50a288c5e7582c2f73167.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/thesafezone_color_xs.png
// module id = 27
// module chunks = 1